<footer class="bg-third text-white py-12">
  <div class="container mx-auto px-4">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
      <!-- Left Section: Branding -->
      <div class="space-y-4">
        <div class="flex items-center gap-2 cursor-pointer" routerLink="/">
          <mat-icon class="text-3xl text-primary">local_bar</mat-icon>
          <span class="text-title font-bold">BarHub</span>
        </div>
        <p class="text-beige text-small">Complete management platform for bars and establishments</p>
      </div>

      <!-- Center Section: Links -->
      <div class="space-y-4">
        <h3 class="text-regular font-semibold text-white">Navigation</h3>
        <ul class="space-y-2">
          <li><a routerLink="/" mat-button routerLinkActive="!bg-white/10" [routerLinkActiveOptions]="{exact: true}"
              class="!text-beige hover:!text-white transition-colors duration-300 p-2">Home</a>
          </li>
          <li><a routerLink="/customer" mat-button routerLinkActive="!bg-white/10"
              class="!text-beige hover:!text-white transition-colors duration-300 p-2">Customer Interface</a></li>
          <li><a routerLink="/service-provider" mat-button routerLinkActive="!bg-white/10"
              class="!text-beige hover:!text-white transition-colors duration-300 p-2">Dashboard</a>
          </li>
        </ul>
      </div>

      <!-- Right Section: Contact & Social -->
      <div class="space-y-4">
        <h3 class="text-regular font-semibold text-white">Contact Us</h3>
        <div class="flex items-center gap-2 text-beige text-small">
          <mat-icon class="text-base">email</mat-icon>
          <span>support&#64;barhub.com</span>
        </div>
        <div class="flex items-center gap-2 text-beige text-small">
          <mat-icon class="text-base">phone</mat-icon>
          <span>+33 (0)1 23 45 67 89</span>
        </div>
        <div class="flex gap-2 mt-4">
          <button mat-icon-button class="!text-beige hover:!text-white hover:!bg-white/10 transition-all duration-300"
            aria-label="Facebook">
            <mat-icon>facebook</mat-icon>
          </button>
          <button mat-icon-button class="!text-beige hover:!text-white hover:!bg-white/10 transition-all duration-300"
            aria-label="Instagram">
            <mat-icon>language</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Copyright -->
    <div class="border-t border-pGray pt-6 mt-6">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4 text-small text-beige">
        <p>&copy; {{ currentYear }} BarHub. All rights reserved.</p>
        <div class="flex items-center gap-4">
          <a href="#" class="hover:text-white transition-colors duration-300">Legal Notice</a>
          <span class="text-pGray">•</span>
          <a href="#" class="hover:text-white transition-colors duration-300">Privacy Policy</a>
          <span class="text-pGray">•</span>
          <a href="#" class="hover:text-white transition-colors duration-300">Terms of Use</a>
        </div>
      </div>
    </div>
  </div>
</footer>